import Skeleton from "../base"

const ConversationsThreadSkeleton = () => {
  return (
    <Skeleton>
      <div className="flex h-full flex-col">
        <div className="flex-1 overflow-hidden">
          <div className="h-full w-full overflow-y-auto">
            <div className="sticky top-0 px-6 py-3 flex items-center bg-white">
              <div className="flex flex-1 items-center">
                <div className="min-w-12 h-12 bg-gray-200 rounded-full"></div>

                <div className="w-20 h-4 bg-gray-200 rounded-full ml-3"></div>
                <div className="w-16 h-4 bg-gray-100 rounded-full ml-auto"></div>
              </div>
            </div>
            <div className="px-4 md:px-8 py-4 flex flex-col lg:max-w-[800px] lg:mx-auto">
              {Array.from({ length: 5 }).map((_, index) => (
                <div
                  key={index}
                  className={`flex flex-1 items-end mt-4 ${
                    index % 2 === 0 ? "flex-row-reverse" : ""
                  }`}
                >
                  <div className="w-10 h-10 bg-gray-200 rounded-full"></div>

                  <div
                    className={`w-1/3 h-12 bg-gray-200 rounded-lg ${
                      index % 2 === 0 ? "mr-3" : "ml-3"
                    }`}
                  ></div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* <div className="bg-white px-4 py-3 mt-auto">
          <div className="flex items-center gap-2">
            <div className="w-5/6 h-8 bg-gray-200 rounded-full"></div>
            <div className="w-1/6 h-8 bg-gray-100 rounded-full"></div>
          </div>
        </div> */}
      </div>
    </Skeleton>
  )
}

export default ConversationsThreadSkeleton
